module.exports = __webpack_public_path__ + "img/75_36.77224588.png";